import script from "./Politique.vue?vue&type=script&setup=true&lang=ts"
export * from "./Politique.vue?vue&type=script&setup=true&lang=ts"

import "./Politique.vue?vue&type=style&index=0&id=59c8644e&lang=css"

const __exports__ = script;

export default __exports__